export default __webpack_public_path__ + "static/media/sides-banner.c42ea37d.jpg";